var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiReference = function SvgApiReference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#api-reference_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M23.833 3.783v6.884c0 .933 0 1.4.182 1.757.16.313.415.568.728.728.357.182.823.182 1.757.182h6.884m-9.55 15.833L28 25l-4.167-4.167m-6.666 0L13 25l4.166 4.167m16.667-12.52v12.02c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185c-1.07.545-2.47.545-5.27.545H15.167c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.186-2.185c-.545-1.07-.545-2.47-.545-5.27V11.333c0-2.8 0-4.2.545-5.27a5 5 0 0 1 2.186-2.185c1.07-.545 2.47-.545 5.27-.545h5.353c1.222 0 1.834 0 2.41.139a5 5 0 0 1 1.445.598c.504.31.937.742 1.801 1.607l5.314 5.313c.865.865 1.297 1.297 1.606 1.802.275.447.477.935.599 1.445.138.576.138 1.187.138 2.41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "api-reference_svg__a",
    x1: 31.467,
    x2: -24.398,
    y1: 4.254,
    y2: 21.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgApiReference;